import Vue from "vue";

// Polyfills for older browsers like ie11 etc
// var Symbol = require('es6-symbol');
import "core-js/fn/string";
import "core-js/fn/symbol";
import "core-js/fn/reflect";

// require("@webcomponents/webcomponentsjs/webcomponents-bundle.js")
import "@webcomponents/webcomponentsjs/webcomponents-bundle.js";

Vue.config.productionTip = false;

import Buefy from "buefy";
import "buefy/dist/buefy.css";
Vue.use(Buefy, {
  defaultIconPack: "fas"
});

import VueTour from "vue-tour";
//require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/fontawesome";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
